import React from 'react';
import Image from 'next/image';

interface Props {
  children: React.ReactNode;
  formHeader: string;
  isRecoverPasswordForm?: boolean;
}

function AuthFormWrapper({ children, formHeader }: Props) {
  return (
    <div
      className={`relative w-full rounded-2xl bg-white px-5 py-5 md:max-w-[500px] md:px-7 md:py-7`}
    >
      {/* form-title */}
      <h3 className="mb-3 block text-xl font-semibold text-primary md:mb-5  md:text-2xl">
        {formHeader}
      </h3>

      {/* form-content */}
      {children}

      {/* lock-image */}
      <div className="-400 absolute -bottom-3 -right-3 ml-auto h-[60px] w-[60px] md:-bottom-2">
        <Image
          src={'/icons/trust-form-icon.svg'}
          alt="trust-form-icon"
          fill={true}
          style={{ objectFit: 'cover' }}
        />
      </div>
    </div>
  );
}

export default AuthFormWrapper;
